import { render, staticRenderFns } from "./caiGouIndex.vue?vue&type=template&id=de3bfa7a&scoped=true"
import script from "./caiGouIndex.vue?vue&type=script&lang=js"
export * from "./caiGouIndex.vue?vue&type=script&lang=js"
import style0 from "./caiGouIndex.vue?vue&type=style&index=0&id=de3bfa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3bfa7a",
  null
  
)

export default component.exports